import React, { useRef } from 'react'
import styles from './DesktopApp.module.scss'
import { useAppDispatch } from '../../../../hooks/reduxHooks'
import { openWindow } from '../../../../redux/slices/WindowSlice/WindowSlice'
import { appI } from '../../../../redux/slices/DesktopSlice/DesktopSlice.types'
import { Box, Typography } from '@mui/material'
import { isMobile } from 'react-device-detect'
import { useDebounce } from 'src/hooks/useDebounce'

const DesktopApp = (
  props: appI & {
    size?: 'small'
    textColor?: string
    onOpen?: () => void
  }
) => {
  // props destructuring
  const { name, icon, id, show, textColor, isNew, onOpen } = props
  const dispatch = useAppDispatch()
  const lastTouched = useRef<number>()
  const debounce = useDebounce()

  const handleOpenApp = () => {
    debounce(() => {
      dispatch(
        openWindow({
          name,
          minimized: false,
          maximized: isMobile,
          icon: props.icon,
          iFrame: props.iFrame,
          app: props.app
        })
      )
      onOpen?.()
    }, 300)
  }

  const handleTouch = () => {
    const currentTime = new Date().getTime()
    if (lastTouched.current) {
      const timeElapsed = currentTime - lastTouched.current
      if (timeElapsed <= 300) handleOpenApp()
    }
    lastTouched.current = currentTime
  }

  return (
    <Box
      id={id}
      onTouchEnd={handleTouch}
      className={styles.desktopApp}
      onClick={() => handleOpenApp()}
      sx={{
        height: '100%',
        width: '100%',
        overflowWrap: 'anywhere',
        userSelect: 'none',
        ...(!show && {
          width: 0,
          height: 0,
          visibility: 'hidden'
        })
      }}
    >
      <Box
        sx={{
          position: 'relative',
          margin: '0',
          display: 'inline-block',
          height: '3rem',
          width: '4rem',
          '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }
        }}
      >
        <img src={icon} alt={name} />
        {isNew && (
          <Typography
            sx={{
              position: 'absolute',
              right: 2,
              top: '60%',
              color: 'white',
              backgroundColor: 'red',
              fontSize: '.7rem',
              paddingX: '.2rem'
            }}
          >
            New
          </Typography>
        )}
      </Box>
      <Typography
        sx={{
          color: 'white',
          margin: 0,
          fontSize: '.85rem',
          textShadow:
            'rgb(0, 0, 0) 1px 0px 0px,rgb(0, 0, 0) 0.540302px 0.841471px 0px,rgb(0, 0, 0) -0.416147px 0.909297px 0px,rgb(0, 0, 0) -0.989992px 0.14112px 0px,rgb(0, 0, 0) -0.653644px -0.756802px 0px,rgb(0, 0, 0) 0.283662px -0.958924px 0px,rgb(0, 0, 0) 0.96017px -0.279415px 0px',
          ...(textColor && {
            color: textColor,
            textShadow: 'none'
          })
        }}
      >
        {name}
      </Typography>
    </Box>
  )
}

export default DesktopApp
